import { useMutation, useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api-client';
import type { UserProfile } from '@chore-project/shared';

export function useMyProfile() {
  return useQuery<UserProfile>({
    queryKey: ['users', 'me', 'profile'],
    queryFn: () => apiClient.get<UserProfile>('/users/me/profile').then((r) => r.data),
  });
}

export function useDeleteAccount() {
  return useMutation({
    mutationFn: () => apiClient.delete('/users/me'),
  });
}
